module.exports = __webpack_public_path__ + "static/media/myProfileIconPrimary.8ebbe755.svg";